import React from "react";
import "./ControlsSwitch.css";

const ControlsSwitch = ({
  toggle = false,
  labelOn,
  labelOff,
  onChange,
  disabled = false,
  disabledTooltip = ""
}) => {
  return (
    <div className={`switch-container${disabled ? ' switch-disabled' : ''}`} title={disabled ? disabledTooltip : undefined}>
      <span className={`switch-label ${!toggle ? 'switch-label-active' : 'switch-label-inactive'}`}>{labelOff}</span>
      <label className="switch-wrapper">
        <input
          type="checkbox"
          checked={toggle}
          onChange={disabled ? undefined : onChange}
          readOnly={disabled}
        />
        <span className="slider"></span>
      </label>
      <span className={`switch-label ${toggle ? 'switch-label-active' : 'switch-label-inactive'}`}>{labelOn}</span>
    </div>
  );
}

export { ControlsSwitch }
